<template>
    <v-content>
        <v-breadcrumbs :items="snackbar.breadcrumbsItems" large></v-breadcrumbs>
        <v-row>
            <v-col
                cols="12"
                sm="4"
                md="3"
                xl="2"
                    v-for="title in snackbar.settings"
                    v-bind:key="title.link"
                    class="viewCard"
            >
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <router-link :to="title.link">
                            <v-card
                                    :elevation="10"
                                    class="teal darken-1 text-center"
                                    height="100"
                                    width="200"
                            >
                                <v-list-item three-line>
                                    <v-list-item-content class="white--text">
                                        <v-row align="center" justify="center">
                                            <span>{{title.name}}</span>
                                        </v-row>
                                        <!-- <v-divider></v-divider>
                                         <v-row align="center" justify="center">
                                             <span>100</span>
                                         </v-row>-->
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </router-link>
                    </template>
                </v-tooltip>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
    export default {
        name: "CompanySettings",
        data() {
            return {
                snackbar: {
                    formModal: false,
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    settings: [
                        {
                            name: "Sections",
                            link: "/SectionsList"
                        }
                    ],
                    breadcrumbsItems: [
                        {
                            text: "Settings",
                            disabled: true,
                            to: "/companySetting",
                            exact: true
                        }
                        ],
                },
                customerData: {
                    updateItem: {}
                },
                dynamicComponent: {
                    current: 'CompanyForm'
                }
            }
        },
        methods: {
            clickEvent(route) {
                this.$router.push({name: route})
            },
            addModal(route) {
                this.snackbar.formModal = true
                this.dynamicComponent.current = route
            },
            dialogueClose() {
                this.customerData.updateItem = {}
                this.snackbar.formModal = false
            },
            formResponse(responseObj) {
                this.snackbar.color = responseObj.status ? 'success' : 'red'
                this.snackbar.text = responseObj.text
                this.snackbar.snackbar = true
            }
        },
        components: {
        }
    }
</script>

<style scoped lang="scss">
    .options {
        border: 2px solid white;
    }

</style>
